import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export interface HelpCaseUser {
  id: number;
  name: string;
  email: string;
}

export interface HelpCase {
  id: number;
  user_id: number;
  help_case_status_id: number;
  content: string;
  file_path: string;
  doubt: string;
  has_video?: boolean;
  created_at: string;
  updated_at: string;
  user?: HelpCaseUser;
  answers: HelpCase[];
}

export interface HelpCaseListResponse {
  items: HelpCase[];
  page: number;
  totalItems: number;
  currentPage: number;
  itemsPerPage: number;
  numberPages: number;
}

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
}

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const getHelpCases = async (
  page: number = 1,
  itemsPerPage: number = 100
): Promise<HelpCaseListResponse> => {
  try {
    const response = await axios.post(
      `${API_URL}/helpcase/get`,
      { page, itemsPerPage },
      {
        headers: getAuthHeaders(),
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getHelpCaseFileUrl = async (helpCaseId: number): Promise<string> => {
  return `${API_URL}/helpcase/file/${helpCaseId}`;
};

export const getLoggedUser = async (): Promise<HelpCaseUser> => {
  try {
    const response = await axios.get(`${API_URL}/user/me`, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    logout();
    throw error;
  }
};

async function sendAnswerVideo(url: string, file: File): Promise<void> {
  const res = await fetch(url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });

  if (!res.ok) {
    throw new Error("Falha no envio do vídeo");
  }
}

export const answerHelpCase = async (
  helpCaseId: number,
  requesterEmail: string,
  content?: string,
  videoFile?: Blob | null
): Promise<any> => {
  const fileName = videoFile instanceof File ? videoFile.name : "gravacao.webm";
  const mimeType = videoFile?.type ?? "video/webm";

  const data: any = {
    help_case_id: helpCaseId,
    requester_email: requesterEmail,
    content: content || "",
  };

  if (videoFile) {
    data.file_name = fileName;
    data.mimetype = mimeType;
  }

  const response = await axios
    .create({ withCredentials: true })
    .request({
      method: "POST",
      url: `${API_URL}/helpcase/answer`,
      headers: getAuthHeaders(),
      data,
    });

  if (videoFile && response.data?.url) {
    const file =
      videoFile instanceof File
        ? videoFile
        : new File([videoFile], fileName, { type: mimeType });

    await sendAnswerVideo(response.data.url, file);
  }

  return response.data;
};
